export function isValidUUID(uuid) {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
}

export function getLastParam(url) {
  const cleanUrl = url.split(/[?#]/)[0];
  return cleanUrl.split('/').filter(Boolean).pop();
}

export function removeLastParam(url) {
  const trimmedUrl = url.endsWith('/') ? url.slice(0, -1) : url;
  const lastSlashIndex = trimmedUrl.lastIndexOf('/');
  if (lastSlashIndex === -1) return trimmedUrl;
  return trimmedUrl.slice(0, lastSlashIndex);
}
